"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { useLang } from "@/contexts/language-context";
import { ShoppingBag, CheckCircle2, ArrowUpRight } from "lucide-react";

const PAIRS = [
  {
    slug: "online-ordering",
    icon: ShoppingBag,
    label: { en: "Online Ordering — 0% Fee", es: "Pedidos en Línea — 0% Fee" },
    desc: {
      en: "The page delivery orders come from. Same menu, Apple Pay, straight to your KDS.",
      es: "La página de donde vienen los pedidos a domicilio. Mismo menú, Apple Pay, directo a tu KDS.",
    },
  },
  {
    slug: "zero-processing-fees",
    icon: CheckCircle2,
    label: { en: "Card Fees, Covered", es: "Fees de Tarjeta, Cubiertos" },
    desc: {
      en: "Stack it. No commission on the food, and with dual pricing card payers cover the processing cost.",
      es: "Súmalo. Sin comisión sobre la comida, y con dual pricing quien paga con tarjeta cubre el costo de procesamiento.",
    },
  },
];

export default function DeliveryPairs() {
  const { t } = useLang();

  return (
    <section className="relative py-24 px-6 bg-white overflow-hidden">
      <div className="max-w-[1080px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-10"
        >
          <div className="text-[11px] font-black tracking-widest uppercase text-redy-secondary/60 mb-3">
            {t("Pairs well with", "Combina bien con")}
          </div>
          <h2 className="text-2xl md:text-[36px] font-black tracking-tight text-redy-charcoal">
            {t("The order comes in. The margin stays in.", "El pedido entra. El margen se queda.")}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {PAIRS.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.slug}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.6, delay: 0.1 * i }}
              >
                <Link
                  href={`/features/${p.slug}`}
                  className="group block bg-[#FAFAF8] rounded-[24px] p-7 border border-black/5 hover:shadow-lg hover:-translate-y-1 transition-all"
                >
                  <div className="flex items-start justify-between mb-5">
                    <div
                      className="w-12 h-12 rounded-[14px] flex items-center justify-center group-hover:scale-110 transition-transform"
                      style={{ backgroundColor: "rgba(244, 114, 43, 0.12)" }}
                    >
                      <Icon className="w-5 h-5" style={{ color: "#D7263D" }} />
                    </div>
                    <ArrowUpRight className="w-5 h-5 text-redy-secondary/40 group-hover:text-redy-charcoal group-hover:rotate-12 transition-all" />
                  </div>
                  <div className="text-[18px] font-black text-redy-charcoal mb-2">
                    {t(p.label.en, p.label.es)}
                  </div>
                  <div className="text-[14px] font-medium text-redy-secondary leading-relaxed">
                    {t(p.desc.en, p.desc.es)}
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
